import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },

  icon: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    borderRadius: '50%',
    backgroundColor: theme.palette.background.paper,
    marginRight: theme.spacing(1),

    '& svg': {
      width: '100%',
      height: '100%',
      padding: theme.spacing(0.5),
    },
  },

  text: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: theme.palette.text.disabled,
  },
}));
